import React, { Component, Fragment } from 'react';
import EnableModal from './Modal';
import ErrorModal from './ErrorModal';
import gql from 'graphql-tag';
import { client } from 'src/apollo';


export default class EnableLink extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      error: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClick() {
    const { show } = this.state;
    this.setState({
      show: !show
    });
  }

  handleSubmit(){ 
    const {id, isActive} = this.props

    const mutation = gql`
        mutation($id: String!, $isActive: Boolean) {
          updateTerminal(id: $id, isActive: $isActive){
            terminal{
              id,
                isActive
            }
          }
        }`;

    client.mutate({
      mutation,
      variables: {id: id, isActive: !isActive},
    }).then((response) => {
      window.location.reload()
    }).catch((error) => {
      this.setState({error: true})
    })

  }

  render () {
    const { isActive } = this.props;
    const { show, error } = this.state;
    return (
      <Fragment>
        {error?
        <Fragment>
          <ErrorModal
            handleClose={this.handleClick}
            show={show}
          />
          <a onClick={this.handleClick}
          href="javascript:void(0)"
          className="dropdown-item"
        >{isActive?'Desabilitar':'Habilitar'}</a>
      </Fragment>
            :
              <Fragment>
                <EnableModal
                  isActive={isActive}
                  handleClose={this.handleClick}
                  handleSubmit={this.handleSubmit}
                  show={show}
                />
                <a onClick={this.handleClick}
                href="javascript:void(0)"
                className="dropdown-item"
              >{isActive?'Desabilitar':'Habilitar'}</a>
            </Fragment>
        }

      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Enable/Link.js